import { types } from 'mobx-state-tree';
import Actions from './Actions';
import Views from './Views';
const Company = types
    .model({
    isLoaded: types.optional(types.boolean, false),
    minSize: types.maybeNull(types.integer),
    maxSize: types.maybeNull(types.integer),
})
    .actions(Actions)
    .views(Views);
export default Company;
